import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Trophy, User, Mail, Lock, UserPlus } from 'lucide-react';
import { useAuth, formatApiError } from '../../context/AuthContext';

const RegisterPage = () => {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(''); setLoading(true);
    try {
      await register(name, email, password);
      navigate('/fantasy', { replace: true });
    } catch (ex) {
      setErr(formatApiError(ex));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-emerald-950 to-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-emerald-500/10 border border-emerald-400/30 mb-4">
            <Trophy className="w-8 h-8 text-emerald-400" />
          </div>
          <h1 className="text-3xl font-bold text-white">Cria a tua conta</h1>
          <p className="text-emerald-300/80 text-sm mt-1 italic">O Manager Oficial da Nossa Pelada</p>
          <p className="text-emerald-200/70 mt-2">Torna-te Treinador do RatingPro Fantasy</p>
        </div>

        <form onSubmit={onSubmit} className="bg-slate-900/60 backdrop-blur border border-white/10 rounded-2xl p-6 shadow-2xl space-y-4" data-testid="register-form">
          <div>
            <label className="text-sm text-slate-300 font-medium">Nome</label>
            <div className="relative mt-1">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <input
                type="text" required autoFocus minLength={2} maxLength={60}
                value={name} onChange={(e) => setName(e.target.value)}
                className="w-full bg-slate-800/70 border border-white/10 rounded-lg pl-10 pr-3 py-2.5 text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500"
                placeholder="O teu nome"
                data-testid="register-name-input"
              />
            </div>
          </div>

          <div>
            <label className="text-sm text-slate-300 font-medium">Email</label>
            <div className="relative mt-1">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <input
                type="email" required
                value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-slate-800/70 border border-white/10 rounded-lg pl-10 pr-3 py-2.5 text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500"
                placeholder="tu@email.pt"
                data-testid="register-email-input"
              />
            </div>
          </div>

          <div>
            <label className="text-sm text-slate-300 font-medium">Senha <span className="text-slate-500">(mín. 6 caracteres)</span></label>
            <div className="relative mt-1">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <input
                type="password" required minLength={6}
                value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-slate-800/70 border border-white/10 rounded-lg pl-10 pr-3 py-2.5 text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500"
                placeholder="••••••••"
                data-testid="register-password-input"
              />
            </div>
          </div>

          {err && <div className="text-sm text-red-300 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2" data-testid="register-error">{err}</div>}

          <button
            type="submit" disabled={loading}
            className="w-full bg-emerald-500 hover:bg-emerald-400 disabled:opacity-50 disabled:cursor-not-allowed text-slate-900 font-semibold rounded-lg py-2.5 flex items-center justify-center gap-2 transition-colors"
            data-testid="register-submit-btn"
          >
            <UserPlus className="w-4 h-4" />
            {loading ? 'A criar...' : 'Criar conta'}
          </button>

          <div className="text-center text-sm text-slate-400 pt-2">
            Já tens conta?{' '}
            <Link to="/login" className="text-emerald-400 hover:text-emerald-300 font-medium" data-testid="register-login-link">
              Entra aqui
            </Link>
          </div>
        </form>

        <div className="text-center mt-6">
          <Link to="/" className="text-slate-400 hover:text-white text-sm">← Voltar ao site</Link>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
